import { render } from "./TabOptions.vue?vue&type=template&id=01123c8a"
import script from "./TabOptions.vue?vue&type=script&lang=ts"
export * from "./TabOptions.vue?vue&type=script&lang=ts"
script.render = render

export default script